import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { apiConstants } from '../../../_constants/api.constants';
import { notificationActions } from "../../../_actions";
import Moment from 'moment';
import config from '../../../config';

class TopBar extends Component {
    constructor(props) {
        super(props);

        this.state = {
            getUserBellNotificationsList: [],
        };
    }

    //-- checking for Notifications
    /*
    * componentDidMount - Initially it will call and get the notifications data
    */
    componentDidMount() {
        //-- bell condition only for Shopkeeper
        if (JSON.parse(sessionStorage.getItem('user')).role_type == 'shopkeeper') {
            const { dispatch } = this.props;
            let postData = {};
            postData.role = 'Shopkeeper';

            dispatch(notificationActions.getUserNotificationsForBell(apiConstants.GET_USERS_NOTIFICATIONS_FOR_BELL, postData));
        }
    }

    /*
    * componentWillReceiveProps - Whenever Props change, it will call and store data
    * update the state values with new props values, this method will get called whenever any change happens to props values
    * componenentDidUpdate()
    */
    componentWillReceiveProps(props) {
        if (props.getUserBellNotificationsList) {
            if (props.getUserBellNotificationsList.getUserBellNotificationsList) {
                if (props.getUserBellNotificationsList.getUserBellNotificationsList.data) {
                    this.setState({
                        getUserBellNotificationsList: props.getUserBellNotificationsList.getUserBellNotificationsList.data.data,
                    })
                }
            }
        }
    }

    render() {
        const { siteConstants } = this.props.language;
        //console.log("this  ", this.state);
        return (
            <Fragment>
                {/* <!-- Topbar --> */}
                <nav className="navbar navbar-expand navbar-light bg-white topbar static-top">

                    {/* <!-- Sidebar Toggle (Topbar) --> */}
                    <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
                        <i className="fa fa-bars"></i>
                    </button>

                    <div>{siteConstants.GEN_DISPLAY_DESCRIPTION}</div>

                    {/* <!-- Topbar Navbar --> */}
                    <ul className="navbar-nav ml-auto">

                        {/* <!-- Nav Item - Search Dropdown (Visible Only XS) --> */}
                        <li className="nav-item dropdown no-arrow d-sm-none">
                            <a className="nav-link dropdown-toggle" href="javascript:void(0)" id="searchDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i className="fas fa-search fa-fw"></i>
                            </a>
                            {/* <!-- Dropdown - Messages --> */}
                            <div className="dropdown-menu dropdown-menu-right p-3 shadow animated--grow-in" aria-labelledby="searchDropdown">
                                <form className="form-inline mr-auto w-100 navbar-search">
                                    <div className="input-group">
                                        <input type="text" className="form-control bg-light border-0 small" placeholder="Search for..." aria-label="Search" aria-describedby="basic-addon2" />
                                        <div className="input-group-append">
                                            <button className="btn btn-primary" type="button">
                                                <i className="fas fa-search fa-sm"></i>
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </li>

                        {/* <!-- Nav Item - Alerts --> */}
                        {JSON.parse(sessionStorage.getItem('user')).role_type == 'shopkeeper' ?
                            <li className="nav-item dropdown no-arrow mx-1">
                                <a className="nav-link dropdown-toggle" href="javascript:void(0)" id="alertsDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i className="fas fa-bell fa-fw"></i>
                                    {/* <!-- Counter - Alerts --> */}
                                    {this.state.getUserBellNotificationsList.length > 0 ?
                                        <span className="badge badge-danger badge-counter">{this.state.getUserBellNotificationsList.length}</span>
                                        : ''
                                    }
                                </a>
                                {/* <!-- Dropdown - Alerts --> */}
                                <div className="dropdown-list dropdown-menu dropdown-menu-right shadow animated--grow-in" aria-labelledby="alertsDropdown">
                                    <h6 className="dropdown-header">{siteConstants.MENU_NOTIFICATIONS}</h6>
                                    {
                                        this.state.getUserBellNotificationsList != undefined && this.state.getUserBellNotificationsList.length > 0 ? this.state.getUserBellNotificationsList.map((notification, index) => {
                                            return (
                                                <a className="dropdown-item d-flex align-items-center" >
                                                    <div className="mr-3">
                                                        <div className="icon-circle bg-success">
                                                            <i className="fas fa-file-alt text-white"></i>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div className="small text-gray-500">{Moment(notification.notification_date).format(config.DateFormat)}</div>
                                                        {notification.title}
                                                    </div>
                                                </a>
                                            )
                                        }) : ''
                                    }

                                    {
                                        this.state.getUserBellNotificationsList.length > 0 ?
                                            <a className="dropdown-item text-center small text-gray-500" href="/user-notifications">{siteConstants.LABEL_MORE_NOTIFICATIONS}</a>
                                            :
                                            <a className="dropdown-item text-center small text-gray-500" href="javascript:void(0)">{siteConstants.GEN_NO_RECORD}</a>
                                    }
                                </div>
                            </li>
                            : ''}
                        <div className="topbar-divider d-none d-sm-block"></div>

                        {/* <!-- Nav Item - User Information --> */}
                        <li className="nav-item dropdown no-arrow">
                            <a className="nav-link dropdown-toggle" href="javascript:void(0)" id="userDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <span className="mr-2 d-none d-lg-inline text-gray-600 small">{JSON.parse(sessionStorage.getItem('user')).firstname}</span>
                                <img className="img-profile rounded-circle" src={JSON.parse(sessionStorage.getItem('user')).profile_image ? config.imgPath + "/" + JSON.parse(sessionStorage.getItem('user')).profile_image : "./assets/img/svg/user.svg"} />
                            </a>
                            {/* <!-- Dropdown - User Information --> */}
                            <div className="dropdown-menu dropdown-menu-right shadow animated--grow-in" aria-labelledby="userDropdown">
                                <a className="dropdown-item" href="/profile">
                                    <i className="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
                                    {siteConstants.MENU_USER_PROFILE}
                                </a>
                                <a className="dropdown-item" href="/change-password">
                                    <i className="fas fa-cogs fa-sm fa-fw mr-2 text-gray-400"></i>
                                    {siteConstants.LABEL_CHANGE_PASSWORD}
                                </a>
                                <div className="dropdown-divider"></div>
                                <Link className="dropdown-item" to="/login" onClick={this.logout}></Link>
                                <a className="dropdown-item" href="/login" onClick={this.logout} data-toggle="modal" data-target="#logoutModal">
                                    <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                                    {siteConstants.MENU_LOGOUT}
                                </a>
                            </div>
                        </li>

                    </ul>

                </nav>
                {/* <!-- End of Topbar --> */}
            </Fragment>
        );
    }
}

//-- Here we are adding Reducer names, so it can be get data from reducers using store
function mapStateToProps(state) {
    const { getUserBellNotificationsList, language } = state;
    return {
        getUserBellNotificationsList,
        language
    };
}

const connectedTopBar = connect(mapStateToProps)(TopBar);
export default connectedTopBar;